import { observeQuickView } from "../woocommerce/observeQuickView";

const CHECK_ICON = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export class SidePanelSize {
  constructor(selectInput) {
    if (selectInput.id !== "pa_taille") return;
    this.selectInput = selectInput;
    this.elementAttributeName = selectInput.id;
    this.html = document.documentElement;
    this.body = document.body;
    this.header = document.getElementById("header");
    this.navbar = document.querySelector(".navbar");

    const closestTr = this.selectInput.closest("tr");
    closestTr.classList.add("side-panel-sizes");
    this.toggleSidePanel = closestTr.querySelector(".size-variation");
    this.sidePanel = closestTr.querySelector(".side-panel-sizes-nav");
    this.sidePanelOverlay = closestTr.querySelector(".side-panel-overlay");
    this.sidePanelItems = [];
    this.isPanelOpen = false;
    this.selectedVariationId = null;
    // Wartości atrybutu dzielącego, których doczytanie się nie powiodło —
    // bez tego buildOptions() próbowałby w kółko i zapętliłby się.
    this.failedValues = new Set();

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleClickItem = this.handleClickItem.bind(this);
    this.init();
  }

  isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  isSmallScreen() {
    return window.matchMedia("(max-width: 576px)").matches;
  }

  getSelectedAttribute() {
    return window.sidePanelSizes.productVariationAttributes.reduce(
      (attributes, attributeName) => {
        const attribute = document.querySelector(
          `form.variations_form #${attributeName}`
        );
        if (attribute) {
          attributes[`${attributeName}`] = {
            slug: attribute.value,
            name: attribute.options[attribute.selectedIndex]?.text || "",
          };
        }
        return attributes;
      },
      {}
    );
  }

  init() {
    if (this.toggleSidePanel) {
      this.toggleSidePanel.addEventListener("click", () =>
        this.isPanelOpen ? this.hidePanel() : this.showPanel()
      );

      this.toggleSidePanel.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.isPanelOpen ? this.hidePanel() : this.showPanel();
        }
      });
    }

    window.addEventListener("resize", () => {
      if (this.isDesktop()) this.hidePanel();
    });

    let $this = this;
    jQuery("form.variations_form").on("found_variation", function () {
      $this.buildOptions();
    });

    this.buildOptions();
  }

  showPanel() {
    if (this.isPanelOpen) return;
    this.isPanelOpen = true;

    this.toggleSidePanel?.classList.add("isActive");
    this.toggleSidePanel?.setAttribute("aria-expanded", "true");
    this.sidePanel?.classList.add("isActive");
    this.sidePanelOverlay?.classList.add("isActive");
    this.body.classList.add("menuIsOpen");
    this.html.classList.add("no-scroll");

    if (
      this.body.classList.contains("single-product") &&
      this.isSmallScreen()
    ) {
      this.navbar?.classList.replace("isLight", "isDark");
    }

    document.addEventListener("keydown", this.handleKeydown);

    setTimeout(() => {
      document.addEventListener("click", this.handleClickOutside);
    }, 1);
  }

  hidePanel() {
    if (!this.isPanelOpen) return;
    this.isPanelOpen = false;

    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleKeydown);

    this.toggleSidePanel?.classList.remove("isActive");
    this.toggleSidePanel?.setAttribute("aria-expanded", "false");
    this.sidePanel?.classList.remove("isActive");
    this.sidePanelOverlay?.classList.remove("isActive");
    this.body.classList.remove("menuIsOpen");
    this.html.classList.remove("no-scroll");
  }

  handleClickOutside(event) {
    if (this.sidePanel?.contains(event.target)) {
      event.stopPropagation();
      return;
    }
    this.hidePanel();
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  /** Wartość atrybutu dzielącego (domyślnie kolor) wybrana w formularzu. */
  getSplitValue() {
    const attribute = window.sidePanelSizes.splitAttribute;
    if (!attribute) return "";

    const element = document.querySelector(
      `form.variations_form #${attribute}`
    );
    return element ? element.value : "";
  }

  /**
   * Na stronie są warianty tylko w kolorze wybranym przy wejściu — przy 960
   * wariantach TILA 2 komplet ważyłby 866 KB. Pozostałe kolory doczytujemy
   * dopiero wtedy, gdy klient faktycznie przełączy kolor.
   */
  async loadVariantsFor(value) {
    const config = window.sidePanelSizes;

    try {
      const url =
        `${config.ajaxUrl}?action=smartwood_size_panel_variants` +
        `&product_id=${encodeURIComponent(config.productId)}` +
        `&value=${encodeURIComponent(value)}`;

      const response = await fetch(url, { credentials: "same-origin" });
      const payload = await response.json();

      if (payload?.success && Array.isArray(payload.data?.variants)) {
        config.productAttributesPrices.push(...payload.data.variants);
        config.loadedValues.push(value);
        return true;
      }
    } catch (error) {
      // Cicho: panel zostaje pusty dla tego koloru, reszta karty działa dalej.
    }

    this.failedValues.add(value);
    return false;
  }

  buildOptions() {
    const splitValue = this.getSplitValue();
    const needsFetch =
      splitValue &&
      !window.sidePanelSizes.loadedValues.includes(splitValue) &&
      !this.failedValues.has(splitValue);

    if (needsFetch) {
      this.loadVariantsFor(splitValue).then(() => this.buildOptions());
      return;
    }

    this.selectedVariationId = this.getSelectedVariant()?.variation_id ?? null;
    this.setValuesInToggleSidePanel();

    const optionsContainer = this.sidePanel?.querySelector(
      ".side-panel-sizes-nav__options"
    );
    if (optionsContainer) {
      optionsContainer.innerHTML = this.buildHTMLOptions();
    }

    this.sidePanelItems =
      this.sidePanel?.querySelectorAll(".side-panel-sizes-nav__item") || [];
    this.closeButton = this.sidePanel?.querySelector(
      ".side-panel-sizes-nav__close"
    );

    // Nasłuchy wieszamy tu, a nie przy otwieraniu panelu: buildOptions() podmienia
    // innerHTML, więc za każdym razem są to nowe węzły i nic się nie dubluje.
    this.sidePanelItems.forEach((item) => {
      item.addEventListener("click", this.handleClickItem);
      item.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.handleClickItem(event);
        }
      });
    });
    this.closeButton?.addEventListener("click", () => this.hidePanel());

    if (this.sidePanel) this.sidePanel.style.display = "block";
  }

  buildHTMLOptions() {
    return Object.entries(window.sidePanelSizes.sortedOptions)
      .map(
        ([width, sizes]) => `
        <div class="side-panel-sizes-nav__group">
          <div class="side-panel-sizes-nav__header">` + wp.i18n.__('Width', 'smartwood') + `: ${width} cm</div>
          ${Object.entries(sizes)
            .map(([length, size]) => {
              const variant = this.matchVariantBySize(size.slug);
              return variant ? this.buildHTMLOption(size, variant) : "";
            })
            .join("")}
        </div>
      `
      )
      .join("");
  }

  buildHTMLOption(size, variant) {
    const isSelected =
      this.selectedVariationId !== null &&
      String(variant.variation_id) === String(this.selectedVariationId);
    const availability = variant.availability;

    const modifiers = isSelected ? "isSelected" : "";

    const availabilityHTML = availability
      ? `<div class="side-panel-sizes-nav__availability side-panel-sizes-nav__availability--${availability.status}">
           <span class="side-panel-sizes-nav__dot"></span>${availability.text}
         </div>`
      : "";

    const indicator = isSelected
      ? CHECK_ICON
      : `<img src="${window.sidePanelSizes.iconChevronDown}" alt="" aria-hidden="true">`;

    return `<div class="side-panel-sizes-nav__item ${modifiers}"
                 data-option="${size.slug}"
                 data-variation-id="${variant.variation_id}"
                 role="button"
                 tabindex="0"
                 aria-pressed="${isSelected}">
              <div class="side-panel-sizes-nav__item-name">
                <div class="side-panel-sizes-nav__row">
                  <div class="side-panel-sizes-nav__size">${size.name}</div>
                  <div class="side-panel-sizes-nav__price">${variant.display_price_html}</div>
                </div>
                ${availabilityHTML}
              </div>
              <div class="side-panel-sizes-nav__indicator">${indicator}</div>
            </div>`;
  }

  matchVariantBySize(size) {
    const selectedAttributes = { ...this.getSelectedAttribute() };
    selectedAttributes[`${this.elementAttributeName}`].slug = size;

    return window.sidePanelSizes.productAttributesPrices.find((variant) =>
      Object.keys(selectedAttributes).every(
        (key) => variant.attributes[key] === selectedAttributes[key].slug
      )
    );
  }

  getSelectedVariant() {
    const selectedAttributes = this.getSelectedAttribute();

    return window.sidePanelSizes.productAttributesPrices.find((variant) =>
      Object.keys(selectedAttributes).every(
        (key) => variant.attributes[key] === selectedAttributes[key].slug
      )
    );
  }

  setValuesInToggleSidePanel() {
    const selectedAttributes = this.getSelectedAttribute();
    const matchingVariant = this.getSelectedVariant();

    if (matchingVariant) {
      const selectedValueElement = this.toggleSidePanel?.querySelector(
        ".size-variation__selected-value"
      );
      const priceElement = this.toggleSidePanel?.querySelector(
        ".size-variation__price"
      );

      if (selectedValueElement) {
        selectedValueElement.textContent =
          selectedAttributes[`${this.elementAttributeName}`].name;
      }
      if (priceElement) {
        priceElement.innerHTML = matchingVariant.display_price_html;
      }
    }
  }

  handleClickItem(event) {
    this.hidePanel();
    const variationIdInput = document.querySelector(
      "form.variations_form .variation_id"
    );
    if (variationIdInput)
      variationIdInput.value =
        event.currentTarget.getAttribute("data-variation-id");
    this.selectInput.value = event.currentTarget.getAttribute("data-option");
    jQuery(this.selectInput).trigger("change");
    observeQuickView();
  }
}

export const setupSidePanelSizes = () => {
  jQuery("body").on("yith_wccl_form_initialized", function () {
    document
      .querySelectorAll("form.variations_form select#pa_taille")
      .forEach((selectInput) => {
        new SidePanelSize(selectInput);
      });
  });
};
